var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "发送优惠券",
            top: "100px",
            width: "60vw",
            "destroy-on-close": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "pram",
              attrs: { model: _vm.pram, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户类型：", prop: "userType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.pram.userType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "userType", $$v)
                        },
                        expression: "pram.userType",
                      },
                    },
                    _vm._l(_vm.USER_TYPE_OPTIONS, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.userType == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客户类型：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.pram.userSource,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "userSource", $$v)
                            },
                            expression: "pram.userSource",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("全部"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("游客"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("工会人员"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pram.userType
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.TYPE_TITLE[_vm.pram.userType] } },
                    [
                      _vm.pram.userType == 3
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择分组",
                                multiple: "",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.pram.groupId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "groupId", $$v)
                                },
                                expression: "pram.groupId",
                              },
                            },
                            _vm._l(_vm.groupList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  value: item.id,
                                  label: item.groupName,
                                },
                              })
                            }),
                            1
                          )
                        : _vm.pram.userType == 4
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择标签",
                                multiple: "",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.pram.tagId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "tagId", $$v)
                                },
                                expression: "pram.tagId",
                              },
                            },
                            _vm._l(_vm.labelLists, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { value: item.id, label: item.name },
                              })
                            }),
                            1
                          )
                        : _vm.pram.userType == 2
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择指定小程序",
                                multiple: "",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.pram.miniProgramId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "miniProgramId", $$v)
                                },
                                expression: "pram.miniProgramId",
                              },
                            },
                            _vm._l(_vm.companyList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { value: item.id, label: item.name },
                              })
                            }),
                            1
                          )
                        : _vm.pram.userType == 1
                        ? [
                            _c("SelectUser", {
                              model: {
                                value: _vm.pram.userIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "userIds", $$v)
                                },
                                expression: "pram.userIds",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-table",
                              {
                                staticClass: "table",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.pram.userIds,
                                  size: "mini",
                                  "highlight-current-row": "",
                                  "header-cell-style": { fontWeight: "bold" },
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "uid",
                                    label: "用户ID",
                                    "min-width": "50",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "nickname",
                                    label: "姓名",
                                    "min-width": "150",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "phone",
                                    label: "手机号",
                                    "min-width": "180",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "groupName",
                                    label: "分组",
                                    "min-width": "180",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { label: "操作", "min-width": "120" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handlerDelete(
                                                    _vm.i,
                                                    scope.row.uid
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2689659181
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.selectCoupon },
                },
                [_vm._v("选择优惠券")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SelectCoupon", {
        ref: "SelectCouponRef",
        on: { doRefresh: _vm.closeEdit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }